import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const { CMS_DATA, CMS_ENV, CMS_LOCALE_LANGUAGE, CMS_COUNTRY, X_CLIENT_HEADER } =
    process.env.REACT_APP_MARKET_VALUES;

export const standardOpeningHoursApi = createApi({
    reducerPath: 'standardOpeningHours',
    baseQuery: fetchBaseQuery({
        baseUrl: CMS_DATA,
        prepareHeaders: (headers) => {
            headers.set('x-client-id', X_CLIENT_HEADER);
            return headers;
        },
    }),
    tagTypes: ['OpeningHours'],
    endpoints: (build) => ({
        getStandardOpeningHours: build.query({
            query: () =>
                CMS_LOCALE_LANGUAGE === null || CMS_LOCALE_LANGUAGE === 'null'
                    ? `?contentType=customerServiceStandardOpeningHours&market=${CMS_COUNTRY}&environment=${CMS_ENV}`
                    : `?contentType=customerServiceStandardOpeningHours&market=${CMS_COUNTRY}&environment=${CMS_ENV}&locale=${CMS_LOCALE_LANGUAGE}`,
            providesTags: ['OpeningHours'],
            transformResponse(response) {
                // maybe a real transform would be needed
                return response;
            },
        }),
    }),
});
export const { useGetStandardOpeningHoursQuery } = standardOpeningHoursApi;
